
<template>
	<div class="vCenter">
		<div class="start" v-bind:class="!showForm ? 'loading' : ''">
			<v-form v-model="valid" ref="form" lazy-validation v-if="showForm">
			
				<div class="blue darken-3 pa-3 elevation-1 login-box">
					<div class="d-block text-md-center white--text mb-3">
						<fleetuse-logo />
					</div>
					<label>Gebruikersnaam</label>
					<v-text-field
						v-model="email"
						:rules="emailRules"
						prepend-icon="account_circle"
						id="username"
						required
					></v-text-field>
					<label>Wachtwoord</label>
					<v-text-field
						type="password"
						v-model="password"
						prepend-icon="star"
						id="password"
						:rules="pwRules"
						required
					></v-text-field>
					<v-btn
						@click="submit"
						block
						class="mx-0"
						color="black"
						dark
						v-if="!loading"
						>Inloggen</v-btn
					>
					<v-progress-circular
						indeterminate
						color="green"
						v-if="loading"
					></v-progress-circular>
				</div>
			</v-form>
		</div>
	</div>
</template>
<script>
import * as utils from '@/utils/utils';
import FleetuseLogo from '@/components/FleetuseLogo';

export default {
	name: 'Login',
	components: { FleetuseLogo },
	data() {
		return {
			valid: false,
			name: '',
			pwRules: [v => !!v || 'Wachtwoord is verplicht'],
			email: '',
			password: '',
			utils: utils,
			showForm: false,
			loading: false,
			emailRules: [
				v => !!v || 'Gebruikersnaam is verplicht',
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					'Ongeldige gebruikersnaam'
			]
		};
	},
	created() {
		if (this.$route.params && this.$route.params.action === '-') {
			this.showForm = true;
			localStorage.removeItem('b');
		} else {
			this.checkToken();
		}
	},
	methods: {
		submit() {
			const self = this;
			if (this.$refs.form.validate()) {
				let data = {
					email: this.email,
					password: this.password
				};

				if (data && data.email.indexOf('.dev') >= 0) {
					data.email = data.email.replace('.dev', '');
					localStorage.setItem('live', 1);
				}
				this.loading = true;
				this.utils
					.setData(basePath + 'api/auth/login', data)
					.then(function(response) {
						self.loading = false;
						if (response && response.b) {
							localStorage.setItem('b', response.b);
							localStorage.setItem('t', response.t);
							localStorage.setItem('username', response.u);

							if (response.t !== 'default') {
								self.initOneSignal();
							}

							self.redirect();
						} else {
							window.emitter.$emit('showToastMessage', {
								msg: response.error,
								type: 'error'
							});
						}
					});
			}
		},
		redirect() {
			window.location.href = '#/reservations';
		},
		checkToken() {
			let self = this;
			if (localStorage.getItem('b')) {
				this.utils
					.getData(basePath + 'api/auth/checkToken')
					.then(function(response) {
						if (response.data == '1') {
							self.showForm = false;
							self.redirect();
						} else {
							self.showForm = true;
						}
					});
			} else {
				this.showForm = true;
			}
		},
		initOneSignal() {
			let OneSignal = window.OneSignal || [];
			OneSignal.push(function() {
				OneSignal.init({
					appId: '4ebad7de-87fb-4fdb-9382-c8c747fd453d'
				});
			});
		}
	}
};
</script>
<style lang="scss">
.start {
	label.v-label--active {
		color: #fff !important;
		margin-top: -5px;
	}
	label:not(.v-label--active) {
		text-indent: 10px;
		color: #fff !important;
	}
	.v-input__control {
		margin-bottom: 20px;

		input {
			background-color: #fff;
			padding-left: 10px;
		}
	}
	&.loading {
		background: transparent url('../assets/icon.png') center center no-repeat;
		min-width: 100%;
		height: 300px;
	}
	.v-messages__message {
		color: yellow;
	}
}
</style>
<style lang="scss" scoped>
form {
	min-width: 400px;
	max-width: 100%;
	margin-top: -80px;
}
.vCenter {
	background: #0b2540 url('../assets/loginbg.jpg') center center no-repeat;
	background-size: cover;
	height: 100%;
	padding: 0;
	margin: 0 auto;
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		display: -webkit-box;
		display: -moz-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		align-items: center;
		justify-content: center;
	}

}

.login-box {
	border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue